module.exports = __webpack_public_path__ + "img/feature_buy_freespin_ph.011fc605.png";